import { Response } from '@angular/http';

export class FormError extends Error {
  code: number;
  errors: any = [];
  api_raw_response: Response;
}



// WEBPACK FOOTER //
// ./src/app/common-theme/models/form-error.model.ts